import React from 'react'
import InformationComp from '../../../components/main/shopping/Information/InformationComp'

export const Information = () => {
  return (
    <div>
      <InformationComp/>
    </div>
  )
}
